import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Status } from 'model/alerts.model';
import { DealsService } from 'service/deals.service';

export type OptionType = { value: string; label: string };

interface DealsState {
  stage: string;
  owner: any;
  owners: any[];
  stages: string[];
  deal: any;
  loading: Status;
}

const initialState: DealsState = {
  stage: '',
  owner: '',
  owners: [],
  stages: [],
  deal: {},
  loading: 'idle',
};

export const fetchDealById = createAsyncThunk('deals/fetchDealById', async (id: string) => {
  const data = await DealsService.getDealById(id);
  return data.data;
});

export const updateDeal = createAsyncThunk('deals/fetchDealById', async (id: string, payload) => {
  await DealsService.updateDeal(id, payload);
});

export const fetchOwners = createAsyncThunk('deals/fetchOwners', async () => {
  const data = await DealsService.getMembers();
  return data;
});

export const fetchStages = createAsyncThunk('deals/fetchStages', async () => {
  const data = await DealsService.getStages();
  return data;
});

const dealsSlice = createSlice({
  name: 'deals',
  initialState,
  reducers: {
    setStage: (state, action) => {
      state.stage = action.payload;
    },
    setOwner: (state, action) => {
      state.owner = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchOwners.fulfilled, (state, action) => {
      state.owners = action.payload;
    });
    builder.addCase(fetchStages.fulfilled, (state, action) => {
      state.stages = action.payload.data.stages.map(
        (item: { stageName: string }) => item.stageName,
      );
    });
    builder.addCase(fetchDealById.fulfilled, (state, action) => {
      state.deal = action.payload;
      state.loading = 'complete';
    });
    builder.addCase(fetchDealById.pending, (state, action) => {
      state.loading = 'in-progress';
    });
  },
});

export const { setStage, setOwner } = dealsSlice.actions;
export default dealsSlice.reducer;
